import type { RoleCategory, SeniorityBand } from './types';

/**
 * Collapse a RoleCategory into the senior/junior band used for ratio stats.
 *
 * - Senior: director, manager, strategist
 * - Junior: lead, specialist
 * - Other: other (explicitly excluded from ratios, not silently dropped)
 *
 * Director counts as senior. This fixes the prior behaviour in
 * calculateSeniorJuniorRatio which dropped Directors entirely.
 */
export function classifySeniorityBand(role: RoleCategory): SeniorityBand {
  switch (role) {
    case 'director':
    case 'manager':
    case 'strategist':
      return 'senior';
    case 'lead':
    case 'specialist':
      return 'junior';
    case 'other':
      return 'other';
  }
}
